import NoRecordFound from "../../../../../components/ui/noRecordFound/NoRecordFound";
const ModalGroupingTable = ({ data = [], isDisabled = true }) => {
    return (
        <>
            <div className="table-title mt-2">
                <h3>Model Grouping</h3>
            </div>

            {data?.length > 0 ? <div className="member-list">
                <div className="content-section">
                    <div className="table-section">
                        <table>
                            <thead>
                                <tr>
                                    <th>Brand Name</th>
                                    <th>Model Name</th>
                                    <th>Cert Number</th>
                                    <th>Cert Suffix</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.map((item) => (
                                    <tr key={item.sgbpProductId}>
                                        <td>{item.brandName || "N/A"}</td>
                                        <td>{item.modelName || "N/A"}</td>
                                        <td>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.applicationNumber ?? ""}
                                                    disabled={isDisabled}
                                                    readOnly
                                                />
                                            </div>
                                        </td>

                                        <td>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.certPrefix ?? ""}
                                                    disabled={isDisabled}
                                                    readOnly
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> : <NoRecordFound />}
        </>
    );
};

export default ModalGroupingTable;